// üzenet-státusz badge — a jel a KÖZÖS badge-katalógusból jön (`domain-badge.tsx`, `messageStatus`
// fogalom): draft → muted · scheduled → info · sent → success, mindegyik vezető ikonnal. a hívó dönti el,
// megjeleníti-e (a lista pl. csak a draft/scheduled-t emeli ki). ez a fájl csak a kényelmes, névre szóló
// API-t tartja meg.
import { DomainBadge } from '@/components/shared/domain-badge';

export interface MessageStatusBadgeProps {
  /** A nyers státusz-string (a jel forrása). */
  status: string;
  /** A megjelenített (lokalizált) címke — a hívó adja `t('messages.statusLabel.…')`-ből. */
  label: string;
  className?: string;
}

export function MessageStatusBadge({
  status,
  label,
  className,
}: MessageStatusBadgeProps): JSX.Element {
  return <DomainBadge kind="messageStatus" value={status} label={label} className={className} />;
}
